import { useRef } from "react";
import { Helmet } from "react-helmet";
import "../Terms/styled.scss";
import "../../../home.scss";
import { Link } from "react-router-dom";

const PrivacyHeader = () => {
  return (
    <div className="section terms_head" style={{}}>
      <div className="content_container">
        <div
          className="content terms_head"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="terms_head_left">
            <h1>Brandclub Privacy Policy</h1>
            <h2>Last Updated: October 18, 2024</h2>
          </div>
        </div>
      </div>
    </div>
  );
};
const PrivacyContent = () => {
  return (
    <div className="section terms" style={{}}>
      <div className="content_container" style={{}}>
        <div className="content terms">
          <div className="terms_body">
            <div className="terms_sec">
              <div className="content">
                <p>
                  <strong></strong>
                  Brand Club LLC (“<strong>Brandclub,</strong>” “
                  <strong>we,</strong>” “<strong>our,</strong>” and/or “
                  <strong>us</strong>”) values the privacy of individuals who
                  use our websites, apps, and related online services
                  (collectively, our “<strong>Services</strong>” or “
                  <strong>Platforms</strong>”). This privacy policy (the “
                  <strong>Privacy Policy</strong>”) explains how we collect,
                  use, and share information from users of our Services (“
                  <strong>Users</strong>”, “<strong>you</strong>”, and/or “
                  <strong>your</strong>”). By using our Services, you agree to
                  the collection, use, disclosure, and procedures this Privacy
                  Policy describes. Beyond the Privacy Policy, your use of our
                  Services is also subject to our Terms of Service. All
                  capitalized not defined in this Privacy Policy shall have the
                  meaning set forth in our Terms of Service.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">What Information we collect</div>
              </div>
              <div className="content">
                <p>
                  We may collect a variety of information from or about you or
                  your devices from various sources, as described below.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Information you provide us</div>
              </div>
              <div className="content">
                <p>
                  <strong>Registration and Profile Information.</strong> When
                  you sign up for a Brandclub account, we ask you for your name,
                  email address, phone number, gender, and date of birth. When
                  you use our Services through a Brand website or app, we will
                  ask for your phone number to identify whether you have an
                  existing Brandclub account; if you do not, we will collect the
                  additional information necessary to create a profile on your
                  behalf. If you sign up using a third-party account, such as
                  Apple or Google, we receive information from that third-party
                  service, such as your name, email address, phone number, and
                  date of birth.
                  <br />
                  <br />
                  <strong>Approved Retailer Account Credentials.</strong> When
                  you link an Approved Retailer account or attempt to make a
                  purchase through our Services, we will ask you to provide the
                  account credentials, such as username and password, that you
                  use to log in to your Approved Retailer account. We may do so
                  by presenting you with a log-in interface similar to the
                  Approved Retailer’s interface.
                  <br /> <br />
                  <strong>Financial Account Information.</strong> We may collect
                  certain payment account information, such as your Venmo or
                  PayPal account information, in order to process and distribute
                  Rewards to you. Those third-party services will then process
                  your payment on our behalf.
                  <br /> <br />
                  <strong>Payment Information</strong>: You may provide us with
                  payment information, such as your payment card number and
                  expiration date, to facilitate purchases with Approved
                  Retailers using their payment service providers. You will not
                  be required to provide us with any payment information to
                  facilitate a purchase if your linked Approved Retailers
                  account has an authorized payment card on file.
                  <br />
                  <br />
                  <strong>Communications</strong>. If you contact us directly,
                  we may receive additional information about you. For example,
                  if you contact us for customer support, we may receive your
                  name, email address, phone number, the contents of the message
                  and any attachments you send to us, and any other information
                  you choose to provide. If you subscribe to our newsletter, we
                  will collect certain information from you, such as your email
                  address. When we send you emails, we may track whether you
                  open them to learn how to deliver a better customer experience
                  and improve our Services.
                  <br />
                  <br />
                  <strong>Product Reviews</strong>. If you choose to submit
                  product reviews through our Services, we will receive any
                  information and content you choose to provide to us, including
                  any pictures or videos attached to your reviews.
                  <br />
                  <br />
                  <strong>User Surveys</strong>. If you participate in a user
                  survey, then Brandclub will collect information from you, such
                  as demographic data, information on your use of the Services,
                  and any additional information you provide us.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">
                  Information we collect when you use our services
                </div>
              </div>
              <div className="content">
                <p>
                  <strong>Location Information.</strong> When you use our
                  Services, we receive your precise location information which
                  we may use for various purposes, such as notifying you about
                  available Brandclub offers when you are visiting a retailer’s
                  store. We also infer your general location information, for
                  example, by using your internet protocol (IP) address.
                  <br />
                  <br />
                  <strong>Device Information</strong>. We receive information
                  about the device and software you use to access our Services,
                  such as your IP address, web browser type, operating system
                  version, phone carrier and manufacturer, application
                  installations, device identifiers, mobile advertising
                  identifiers, and push notification tokens.
                  <br />
                  <br />
                  <strong>Transaction Information</strong>. When you make a
                  purchase through our Services, we will collect details about
                  that transaction, including your name, address, payment
                  method, and items purchased.
                  <br />
                  <br />
                  <strong>Approved Retailer Account Information</strong>. When
                  you provide us with Approved Retailer account credentials, we
                  use those credentials to collect information about your
                  historical and future purchases with that Approved Retailer to
                  facilitate our Services and determine whether you are eligible
                  to earn a Reward. We will also collect your profile
                  information for that account, such as your billing and
                  shipping address.
                  <br />
                  <br />
                  <strong>Usage Information</strong>. To help us understand how
                  you use our Services and to help us improve them, we
                  automatically receive information about your interactions with
                  our Services, such as the pages or other content you view, the
                  searches you conduct, purchases you make, any content you
                  post, and the dates and times of your visits.
                  <br />
                  <br />
                  <strong>Your Contacts</strong>. If you permit us to access the
                  address book on your device, we will access and store names
                  and contact information from your address book to facilitate
                  invitations and social interactions that you initiate through
                  our Services and for other purposes described in this privacy
                  policy or at the time of consent or collection. We also
                  collect your contacts if you invite them to use our Services
                  or share information or content with them from our Services.
                  <br />
                  <br />
                  <strong>
                    Information from Cookies and Similar Technologies
                  </strong>
                  . We and third-party partners collect information using
                  cookies, pixel tags, or similar technologies. Our third-party
                  partners, such as analytics partners, may use these
                  technologies to collect information about your online
                  activities over time and across different services. Cookies
                  are small text files containing a string of alphanumeric
                  characters. We may use both session cookies and persistent
                  cookies. A session cookie disappears after you close your
                  browser. A persistent cookie remains after you close your
                  browser and may be used by your browser on subsequent visits
                  to our Services. Please review your web browser’s “Help” file
                  to learn the proper way to modify your cookie settings. Please
                  note that if you delete or choose not to accept cookies from
                  the Service, you may not be able to utilize the features of
                  the Service to their fullest potential.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">
                  Other information we receive from third parties
                </div>
              </div>
              <div className="content">
                <p>
                  <strong>Brands</strong>. We may receive information from
                  Brands, such as customer contact information and combine it
                  with other information we have about you or use it to contact
                  you to join our Service.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">
                  How we use the information we collect
                </div>
              </div>
              <div className="content">
                <p>
                  We may use the information we collect:
                  <br />
                  <br />
                  To provide, maintain, improve, and enhance our Services;
                  <br />
                  <br />
                  To provide you with earned Rewards, subject to our{" "}
                  <Link to={"/rewardterms"}>Rewards Terms and Conditions</Link>;
                  <br />
                  <br />
                  To provide insights and Services to Approved Retailers and
                  Brands;
                  <br />
                  <br />
                  To personalize your experience on our Services such as by
                  providing tailored content and recommendations;
                  <br />
                  <br />
                  To understand and analyze how you use our Services and develop
                  new products, services, features, and functionality;
                  <br />
                  <br />
                  To communicate with you, provide you with updates and other
                  information relating to our Services, provide information that
                  you request, respond to comments and questions, and otherwise
                  provide customer support;
                  <br />
                  <br />
                  To update your status on your social networks, to send
                  messages on your behalf to your social networks, and to
                  provide other features and services to you;
                  <br />
                  <br />
                  For marketing and advertising purposes, such as developing and
                  providing promotional and advertising materials that may be
                  relevant, valuable or otherwise of interest to you;
                  <br />
                  <br />
                  To send you text messages, emails, and push notifications;
                  <br />
                  <br />
                  To facilitate transactions and payments;
                  <br />
                  <br />
                  To find and prevent fraud, and respond to trust and safety
                  issues that may arise;
                  <br />
                  <br />
                  For compliance purposes, including enforcing our Terms of
                  Service or other legal rights, or as may be required by
                  applicable laws and regulations or requested by any judicial
                  process or governmental agency; and
                  <br />
                  <br />
                  For other purposes for which we provide specific notice at the
                  time the information is collected.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">
                  How we share the information we collect
                </div>
              </div>
              <div className="content">
                <p>
                  <strong>Affiliates</strong>. We may share any information we
                  receive with our affiliates for any of the purposes described
                  in this Privacy Policy.
                  <br />
                  <br />
                  <strong>Vendors and Service Providers</strong>. We may share
                  any information we receive with vendors and service providers
                  retained in connection with the provision of our Services.
                  <br />
                  <br />
                  <strong>Business Partners</strong>. We may share data with
                  third-party business partners to facilitate the provision of
                  our Services. We utilize data security best practices, such as
                  secure data clean rooms and advanced encryption techniques, to
                  ensure personally identifiable information is not exposed to
                  our business partners when sharing data.
                  <br />
                  <br />
                  <strong>User Reviews</strong>. The reviews that you provide
                  through our Services will be shared with Brands and may be
                  publicly posted on the Brand’s website and apps. These reviews
                  will be publicly viewable outside of our Services, and we are
                  not responsible for any third-party’s use of available
                  information, so you should carefully consider whether and what
                  to post or how you identify yourself through these reviews.
                  <br />
                  <br />
                  <strong>Brands</strong>. When you use our Services, we will
                  share the information we collect about you, including your
                  current, historical, and future purchase activity on Approved
                  Retailers websites, as well as your Approved Retailer account
                  profile information, with participating Brands.
                  <br />
                  <br />
                  <strong>Approved Retailers</strong>. We may share aggregate,
                  redacted, or anonymized data with Approved Retailers to
                  provide them with insights into the efficiency of their
                  marketing practices.
                  <br />
                  <br />
                  <strong>Analytics Partners</strong>. We use analytics services
                  such as Google Analytics to collect and process certain
                  analytics data. These services may also collect information
                  about your use of other websites, apps, and online resources.
                  You can learn more about Google’s practices by visiting
                  https://www.google.com/policies/privacy/partners/.
                  <br />
                  <br />
                  <strong>As Required by Law and Similar Disclosures</strong>.
                  We may access, preserve, and disclose your information if we
                  believe doing so is required or appropriate to: (a) comply
                  with law enforcement requests and legal process, such as a
                  court order or subpoena; (b) respond to your requests; or (c)
                  protect your, our, or others’ rights, property, or safety. For
                  the avoidance of doubt, the disclosure of your information may
                  occur if you post any objectionable content on or through the
                  Services.
                  <br />
                  <br />
                  Merger, Sale, or Other Asset Transfers. We may transfer your
                  information to service providers, advisors, potential
                  transactional partners, or other third parties in connection
                  with the consideration, negotiation, or completion of a
                  corporate transaction in which we are acquired by or merged
                  with another company or we sell, liquidate, or transfer all or
                  a portion of our assets. The use of your information following
                  any of these events will be governed by the provisions of this
                  Privacy Policy in effect at the time the applicable
                  information was collected.
                  <br />
                  <br />
                  <strong>Aggregated Statistics</strong>. We may share
                  aggregated, redacted, or anonymized forms of any information
                  we receive (“<strong>Anonymized Data</strong>”). We may
                  display this information publicly or provide it to others,
                  including selling Anonymized Data to third parties. We may
                  use, disclose, market and license Anonymized Data for any
                  purpose without restriction. However, we do not disclose
                  personally-identifying information other than as described
                  herein.
                  <br />
                  <br />
                  <strong>Consent</strong>. We may also disclose your
                  information with your permission.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Your choices and preferences</div>
              </div>
              <div className="content">
                <p>
                  <strong>Communication Preferences</strong>. You can adjust the
                  settings in your account to indicate what types of
                  communications you would like to receive from brands.
                  <br />
                  <br />
                  <strong>Location Information</strong>. You can limit the
                  sharing of precise location information through your device’s
                  operating system settings.
                  <br />
                  <br />
                  <strong>Marketing Communications</strong>. You can unsubscribe
                  from our promotional emails via the link provided in the
                  emails. Even if you opt out of receiving promotional messages
                  from us, you will continue to receive administrative messages
                  from us.
                  <br />
                  <br />
                  <strong>Do Not Track</strong>. There is no accepted standard
                  on how to respond to Do Not Track signals, and we do not
                  respond to such signals.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Third parties</div>
              </div>
              <div className="content">
                <p>
                  Our Services may contain links to other websites, products, or
                  services that we do not own or operate. We are not responsible
                  for the privacy practices of these third parties. Please be
                  aware that this Privacy Policy does not apply to your
                  activities on these third-party services or any information
                  you disclose to these third parties. We encourage you to read
                  their privacy policies before providing any information to
                  them.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Security</div>
              </div>
              <div className="content">
                <p>
                  We make reasonable efforts to protect your information by
                  using safeguards designed to improve the security of the
                  information we maintain. However, as no electronic
                  transmission or storage of information can be entirely secure,
                  we can make no guarantees as to the security or privacy of
                  your information.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Children</div>
              </div>
              <div className="content">
                <p>
                  The privacy of children is important to us. We do not
                  knowingly collect, maintain, or use personal information from
                  children under 13 years of age, and no part of our Services
                  are directed to children. If you learn that a child has
                  provided us with personal information in violation of this
                  Privacy Policy, then you may alert us at
                  privacy@brandclub.com.
                </p>
              </div>
            </div>

            <div className="terms_sec">
              <div className="title">
                <div className="text">International transfers of data</div>
              </div>
              <div className="content">
                <p>
                  Our Services are hosted in the United States and intended for
                  visitors located within the United States. If you choose to
                  use the Services from the European Union or other regions of
                  the world with laws governing data collection and use that may
                  differ from U.S. law, then please note that you are
                  transferring your personal information outside of those
                  regions to the United States for storage and processing. Also,
                  we may transfer your data from the U.S. to other countries or
                  regions in connection with storage and processing of data,
                  fulfilling your requests, and operating the Services. By
                  providing any information, including personal information, on
                  or to the Services, you consent to such transfer, storage, and
                  processing.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">
                  Accessing and updating your information
                </div>
              </div>
              <div className="content">
                <p>
                  You can update your account and profile information through
                  your profile settings.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Changes to this privacy policy</div>
              </div>
              <div className="content">
                <p>
                  We will post any adjustments to the Privacy Policy on this
                  page, and the revised version will be effective when it is
                  posted. If we materially change the ways in which we use or
                  share personal information previously collected from you
                  through the Services, we will notify you through the Services,
                  by email, or other communication. We recommend that you review
                  the Privacy Policy each time you visit our Platforms to stay
                  informed of our privacy practices.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Contact us</div>
              </div>
              <div className="content">
                <p>
                  If you have any questions, comments, or concerns about our
                  processing activities, please email us at
                  privacy@brandclub.com or write to us at 801 5th Ave, Suite
                  2800, Seattle, WA 98104.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">
                  Additional State-Specific Information
                </div>
              </div>
              <div className="content">
                <p>
                  <strong>Information for California Residents</strong>
                  <br />
                  <br />
                  The California Consumer Privacy Act of 2018 (as amended by the
                  California Privacy Rights Act of 2020) and its implementing
                  regulations gives California residents specific privacy
                  rights. Please use the link below to read about your rights,
                  or to request access or deletion of your personal information:
                  <Link to={"/californiaprivacy"}>
                    brandclub.com/californiaprivacy
                  </Link>
                  <br />
                  <br />
                  <strong>
                    Information for Residents of Colorado, Connecticut,
                    Delaware, Florida, Indiana, Iowa, Kentucky, Maryland,
                    Minnesota, Montana, Nebraska, New Hampshire, New Jersey,
                    Oregon, Tennessee, Texas, Utah, and Virginia
                  </strong>
                  <br />
                  <br />
                  If you are a resident of Colorado, Connecticut, Delaware,
                  Florida, Indiana, Iowa, Kentucky, Maryland, Minnesota,
                  Montana, Nebraska, New Hampshire, New Jersey, Oregon,
                  Tennessee, Texas, Utah, or Virginia, you have certain rights
                  related to your personal information:
                  <br />
                  <br />
                  <li>
                    Right to Access: You have the right to request access to the
                    personal information we hold about you.
                  </li>
                  <li>
                    Right to Correct: You can request corrections to any
                    inaccurate personal information.
                  </li>
                  <li>
                    Right to Delete: You have the right to request the deletion
                    of your personal information, subject to certain exceptions.
                  </li>
                  <li>
                    Right to Data Portability: You can request a copy of your
                    personal information in a portable format.
                  </li>
                  <li>
                    Right to Opt-Out: You have the right to opt-out of the sale
                    of your personal information and targeted advertising.
                  </li>
                  <br />
                  <br />
                  Exercising Your Rights: To exercise your rights, please
                  contact us at privacy@brandclub.com. We will respond to your
                  request within the timeframes required by applicable law. You
                  may appeal our decision with respect to a request you have
                  submitted by sending follow-up correspondence to
                  privacy@brandclub.com.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Privacy = () => {
  const ref = useRef(undefined) as any;
  const disable = false;
  if (disable) {
    return <></>;
  }
  return (
    <div
      className="site"
      style={{
        height: "unset",
      }}
      ref={ref}
    >
      <Helmet>
        <title>Privacy Policy</title>
        <meta
          name="description"
          content="How we collect and use data, plus your rights as a Brandclub user."
        />
      </Helmet>
      <PrivacyHeader />
      <PrivacyContent />
    </div>
  );
};
export default Privacy;
